import * as utils from '../../../core/utils/utils'

export class TraceabilityPallet {
  /** Business unit number */
  batchBU: string

  /** Site code */
  id: string

  /** Pallet production datetime (YYYY-MM-DDTHH:mm:ss) */
  datetime: string
  get datetimeAsDate(): Date {
    return utils.strDateTimeToDate(this.datetime)
  }

  /** Consumed quantity and unit */
  consumedQuantity: { value: string; unit: string }

  /** Received quantity and unit */
  receivedQuantity: { value: string; unit: string }

  /** Provisioning date and time */
  provisioningDatetime: string
  get provisioningDatetimeAsDate(): Date {
    return utils.strDateTimeToDate(this.provisioningDatetime)
  }

  /** Parent batch number */
  parentBatchNumber: string

  constructor(pallet: TraceabilityPallet) {
    this.batchBU = pallet.batchBU || ''
    this.id = pallet.id || ''
    this.datetime = pallet.datetime || ''
    this.consumedQuantity =
      pallet.consumedQuantity && pallet.consumedQuantity.value !== '0'
        ? pallet.consumedQuantity
        : null
    this.receivedQuantity =
      pallet.receivedQuantity && pallet.receivedQuantity.value !== '0'
        ? pallet.receivedQuantity
        : null
    this.provisioningDatetime = pallet.provisioningDatetime || ''
    this.parentBatchNumber = pallet.parentBatchNumber || ''
  }
}
